import { z } from "zod";
import { applyFieldValidators } from "./utils/applyFieldValidators";
import { PROFILE_UPDATE_CUSTOM_FORM_FIELD_VALIDATORS } from "./const/fieldValidator";
import { ADDRESS_LINE2_INVALID, ANNUAL_INCOME_INVALID, CITY_INVALID, CITY_RANGE_LENGTH, MAX_ANNUAL_INCOME, REQUIRED_MESSAGE, } from "./const/errorMessages";
import { REGEX_ADDRESS2, REGEX_ALPHABETS, REGEX_NUMBERS, } from "../const/regexes";
export var PROFILE_FORM_UPDATE_SCHEMA = z
    .object({
    mailingAddress: z.object({
        street1: z.string().min(1, REQUIRED_MESSAGE),
        street2: z
            .string()
            .regex(REGEX_ADDRESS2, ADDRESS_LINE2_INVALID)
            .optional(),
        state: z.string().optional(),
        city: z
            .string()
            .min(1, REQUIRED_MESSAGE)
            .min(2, CITY_RANGE_LENGTH)
            .max(18, CITY_RANGE_LENGTH)
            .regex(REGEX_ALPHABETS, CITY_INVALID),
        zipCode: z.string().min(1, REQUIRED_MESSAGE),
    }),
    phoneNumbers: z.object({
        mobile: z.string().optional(),
        business: z.string().optional(),
        home: z.string().optional(),
    }),
    emailAddress: z.string().min(1, REQUIRED_MESSAGE),
    annualNetIncome: z
        .string()
        .max(7, MAX_ANNUAL_INCOME)
        .regex(REGEX_NUMBERS, ANNUAL_INCOME_INVALID)
        .optional(),
})
    .superRefine(function (data, ctx) {
    applyFieldValidators(data, ctx, PROFILE_UPDATE_CUSTOM_FORM_FIELD_VALIDATORS);
});
var PAYLOAD_CONTACT_SCHEMA = z.object({
    contactType: z.string(),
    "cipher.contactNumber": z.string(),
});
export var PAYLOAD_NUMBERS_SCHEMA = z.array(PAYLOAD_CONTACT_SCHEMA);
export var PAYLOAD_MAILING_ADDRESS_SCHEMA = z.object({
    "cipher.addressLine1": z.string(),
    "cipher.addressLine2": z.string(),
    "cipher.city": z.string(),
    "cipher.state": z.string(),
    "cipher.zipCode": z.string(),
});
export var PROFILE_UPDATE_PAYLOAD_SCHEMA = z.object({
    "cipher.annualNetIncome": z.string().optional(),
    "cipher.email": z.string().optional(),
    mailingAddress: PAYLOAD_MAILING_ADDRESS_SCHEMA.optional(),
    phone: PAYLOAD_NUMBERS_SCHEMA.optional(),
});
